'use client';

import type { FragmentType } from '@packages/gql/generated/shopping';
import { getFragmentData } from '@packages/gql/generated/shopping';
import { EcoLabelCardFragmentFragmentDoc } from '@packages/gql/generated/shopping/EcoLabelCardFragmentFragmentDoc';
import { Card, CardContent, CardHeader } from '@packages/shared/src/ui/Card/Card';
import { useIntl } from 'react-intl';
import { EcoLabelItem } from '../EcoLabelItem';
import { EcoLabelCardMessages } from './messages';

/* GraphQL */ `
  fragment EcoLabelCardFragment on Product {
    ecoLabels {
      ...EcoLabelItemFragment
    }
  }
`;

export type EcoLabelCardProps = {
  ecoLabelsData: FragmentType<typeof EcoLabelCardFragmentFragmentDoc>;
};

/**
 * <p>This component renders all eco-labels of a product.</p>
 * <i>A product can have multiple eco-labels.</i>
 * */
export const EcoLabelCard = ({ ecoLabelsData }: EcoLabelCardProps) => {
  const { formatMessage } = useIntl();
  const { ecoLabels } = getFragmentData(EcoLabelCardFragmentFragmentDoc, ecoLabelsData);

  if (ecoLabels.length === 0) return null;

  return (
    <Card>
      <CardHeader hasDivider>{formatMessage(EcoLabelCardMessages.DialogHeadline)}</CardHeader>
      <CardContent className="py-2">
        <ul className="list-none space-y-2">
          {ecoLabels.map((ecoLabel, idx) => (
            // rule is disabled because this list is not being reordered
            // eslint-disable-next-line react/no-array-index-key
            <li key={idx}>
              <EcoLabelItem ecoLabelData={ecoLabel} />
            </li>
          ))}
        </ul>
      </CardContent>
    </Card>
  );
};
